export default __webpack_public_path__ + "static/media/arrowRightHover.f374d0f0.svg";